var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalAlign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 18,
      height: 16
    },
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50754 8.97889H0.339614V7.95633H5.50754L3.23012 5.21383L3.83047 4.49088L7.13281 8.46761L3.83047 12.4443L3.23012 11.7214L5.50754 8.97889Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0606 7.90979H17.2285V8.93234H12.0606L14.338 11.6748L13.7376 12.3978L10.4353 8.42106L13.7376 4.44434L14.338 5.16728L12.0606 7.90979Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.13647,
    width: 1.77778,
    height: 16,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalAlign);
export default __webpack_public_path__ + "static/media/horizontal_align.e8017b93cf52855bc8d66dc0b77057f4.svg";
export { ForwardRef as ReactComponent };